import { FlowMappings, ProcessAction } from './actions.dictionary'
import { RuntimeComponentDefinition } from './custom-component.dictionary'
import { TemplateSequence } from './process.dictionary'
import { TemplateConfigResponse } from './template-config.dictionary'

export type ProcessInstance = {
  uuid: string
  processDefinitionName?: string
  parentProcessUuid?: string
  subprocessesUuids?: string[]
  subprocessIds: string[]
  tokens: ProcessToken[]
  templatesSequence?: TemplateSequence[]
  prevUserTaskId?: number | null
  prevUserTaskContext?: string | null
}

export type ProcessToken = {
  uuid: string
  currentNodeId: number
  currentContext?: string
  currentNodeName?: string
  dateUpdated?: string
  id?: number
  initiatorId?: number
  initiatorType?: number
  startNodeId?: number
  state?: TOKEN_STATE
  statusCurrentNode?: NodeState
  currentTemplateId?: number
  lastUserTaskContext?: string
  lastUserTaskNodeId?: number
}

export enum TOKEN_STATE {
  ACTIVE = 'ACTIVE',
  ON_HOLD = 'ON_HOLD',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  ABORTED = 'ABORTED',
  DISMISSED = 'DISMISSED',
  TERMINATED = 'TERMINATED',
  MIGRATING = 'MIGRATING',
  MIGRATED = 'MIGRATED',
  MOVING = 'MOVING',
  MOVED = 'MOVED',
}

export enum NodeState {
  EXECUTED_PARTIAL = 'EXECUTED_PARTIAL',
  EXECUTED_COMPLETE = 'EXECUTED_COMPLETE',
  ARRIVED = 'ARRIVED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  SCHEDULED_FOR_RETRY = 'SCHEDULED_FOR_RETRY',
  EXECUTING = 'EXECUTING',
  WAITING_MESSAGE_EVENT = 'WAITING_MESSAGE_EVENT',
  WAITING_TIMER_EVENT = 'WAITING_TIMER_EVENT',
  WAITING_MESSAGE = 'WAITING_MESSAGE',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  ERROR_MESSAGE_RECEIVED = 'ERROR_MESSAGE_RECEIVED',
}

export type ProcessDataResponse = {
  data: Record<string, any>
  actions: ProcessAction[]
}

export interface StartProcessResponse {
  uuid: string
  processDefinitionName?: string
  tokens: ProcessToken[]
  generalData?: { notifications?: any[] }
  subprocessesUuids?: any[]
  templatesSequence?: TemplateSequence[]
  prevUserTaskId?: number | null
  prevUserTaskContext?: string | null
  customComponents?: RuntimeComponentDefinition[]
}

export interface StatusProcessResponse extends StartProcessResponse {
  templateConfig: TemplateConfigResponse[]
  nodeSequences: number[]
  readOnly: boolean
  allSubprocessesUuids?: string[]
  mappings: FlowMappings
  ccMappings?: FlowMappings
  // template↔component mappings for bundled custom components inside reusable-template
  // embeds, keyed by `${reusableUiTemplateContext}:${componentFlowxUuid}`
  ccRutMappings?: FlowMappings
  applicationId: string
  resourceDefinitionId: string
}
